/**
 * Legacy: Forms Plus
 *
 * Looks like this adds data attributes to certain forms, such as adding
 * `data-wrapper-for` to .mktoFormRow
 *
 * Note: Not sure where this is used so it'll just be enqueued globally
 *
 * @TODO: This could be rewritten and drastically simplified with jQuery, atm
 * it's an indecipherable mess
 *
 * @module legacy/LFormsPlus
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	// @note: Looks like this is related to Marketo, it seems to be sourced from here:
	// https://gist.github.com/dmurphy1/80353db25cab988555be584f6c9ac629
	// Originally this was minified into a few lines, so I've expanded it here during #434 and mentioned what's not in that gist.
	// The 3 main comments are in the gist, the `@note` comments are mine (--CB)
	// It looks like this code is older than the gist, as the gist uses Array.prototype.foreach whereas this code uses an older approach
	// The mentioned author "Sanford Whiteman" is also the author of this seemingly related script:
	// https://assets.codepen.io/250687/teknkl-formsplus-1.0.5.js
	// Which can be seen in use for this codepen: (found by searching for `window.FormsPlus`)
	// https://codepen.io/figureone/pen/jOWVZMg




	// Add data attribute for each Marketo form wrapper.
	window.FormsPlus = window.FormsPlus || {
		allDescriptors: {},
		allMessages: {},
		detours: {}
	};

	/*! @author Sanford Whiteman @license MIT */
	FormsPlus.tagWrappers = function tagWrappers()
	{
		var ANCESTORS_STOR = '.mktoFormRow, .mktoFormCol';
		var INPUTS_STOR = 'INPUT,SELECT,TEXTAREA,BUTTON,[data-name],.mktoPlaceholder,LEGEND'; // @note: the gist stops at BUTTON
		var attrTag = 'data-wrapper-for';
		var attrDone = 'data-initial-wrapper-tagging-complete'; // @note: not in original gist
		var placeholderPrefix = 'mktoPlaceholder'; // @note: not in original gist
		var arrayify = getSelection.call.bind([].slice);

		/* utility fn to tag wrapper containers with inner form inputs */
		function tagMktoWrappers(formEl)
		{
			// Loop over rows ("ancestors")
			arrayify(formEl.querySelectorAll(ANCESTORS_STOR)).forEach(function (ancestor)
			{
				ancestor.setAttribute(attrTag, '');

				// Loop over inputs within each row
				arrayify(ancestor.querySelectorAll(INPUTS_STOR)).forEach(function (input)
				{
					var currentTag = ancestor.getAttribute(attrTag);

					ancestor.setAttribute(
						attrTag,
						[
							currentTag ? currentTag : '',
							input.id,
							input.name != input.id ? input.name : '',
							input.getAttribute('data-name'),
							input.nodeName == 'LEGEND' ? input.textContent : '',
							arrayify(input.classList)
								.filter(function (cls) {
									return cls.indexOf(placeholderPrefix) == 0;
								})
								.map(function (cls) {
									ancestor.classList.add(placeholderPrefix);
									return cls.replace(placeholderPrefix, '', 0);
								})
								.join(' '),
						]
						.join(' ')
						.trim()
					);
				});

				// CUSTOM (since #814):
				// If an ancestor (row) has no inputs, the code above will set it to
				// data-wrapper-for="" (ie. blank). This edit sets the attribute's
				// value to "NONE" instead. This is useful for targetting rows with
				// text and no input, eg. T&Cs shown just before the submit button
				if ( ancestor.getAttribute( attrTag ) === '' )
				{
					ancestor.setAttribute( attrTag, 'NONE' );

					// Also add a custom class, `.mktoFormRow--noinputs`
					ancestor.classList.add( 'mktoFormRow--noinputs' );
				}
			});
		}

		MktoForms2.whenRendered(function (form) {
			var formEl = form.getFormElem()[0];
			tagMktoWrappers(formEl);
			formEl.setAttribute(attrDone, 'true'); // @note: This wasn't part of the gist linked above
		});
	};

	FormsPlus.tagWrappers();
}

// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
